import React from 'react';
import { Dropdown, Option } from '@ontruck/ontruck-react-components/lib/Dropdown';
import {
  featurePreferenceToggle,
  ALLOW_VALIDATE_PAYMENT_METHOD,
} from 'modules/preferences-manager/preferences';

const PaymentMethod = ({ value, handleChange, t }) => {
  const paymentMethodValidationEnabled = featurePreferenceToggle(ALLOW_VALIDATE_PAYMENT_METHOD);
  return paymentMethodValidationEnabled ? (
    <Dropdown light="true" openToTop={true} value={value} onChange={handleChange}>
      <Option value={null}>{t.labels.no_payment_method}</Option>
      <Option value="DIRECT_DEBIT">{t.labels.payment_method['DIRECT_DEBIT']}</Option>
      <Option value="CARD">{t.labels.payment_method['CARD']}</Option>
      <Option value="CONFIRMING">{t.labels.payment_method['CONFIRMING']}</Option>
      <Option value="IOU">{t.labels.payment_method['IOU']}</Option>
      <Option value="TRANSFER">{t.labels.payment_method['TRANSFER']}</Option>
    </Dropdown>
  ) : null;
};

export default PaymentMethod;
